import { apiGet, apiPost } from '@/lib/http';
import type { User } from '@/types/api';

export const authApi = {
  me: () => apiGet<User>('v1/auth/me'),
  login: (credentials: { username: string; password: string }) =>
    apiPost<User>('v1/auth/login', credentials),
  logout: () => apiPost<{ ok: true }>('v1/auth/logout'),
};
